import { render, staticRenderFns } from "./ClientCoordinator.vue?vue&type=template&id=ec89ac6a"
import script from "./ClientCoordinator.vue?vue&type=script&lang=js"
export * from "./ClientCoordinator.vue?vue&type=script&lang=js"
import style0 from "./ClientCoordinator.vue?vue&type=style&index=0&id=ec89ac6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports